module.exports = __webpack_public_path__ + "media/images/v2/icon3-056f9c413314cab5f79e281c0f6d11d9.png";